<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">设置白名单</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 20px;">

        <el-button plain type="primary" size="mini" @click="AddBmd">添加</el-button>

        <el-table v-loading="tableLoading"  :data="listPhone" style="margin-top: 5px;" height="270">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click.native.prevent="deleteRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="success" size="mini" @click="addSubmit">提交</el-button>
      </div>
    </div>

    <AddBmdCTD ref="myAddBmdCTD" v-show="addShow" v-on:closeMe="addShow=false"
               v-on:listBmd="listBmd"></AddBmdCTD>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";

import AddBmdCTD from "./AddBmdCTD";

export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      tableLoading:false,
      addShow:false,

      addForm:{
        timeStr:timeStr,
        sign:'',

        deviceQLSignCode:'',

      },

      listPhone:[],

    }
  },
  components: {
    AddBmdCTD
  },
  methods: {
    init(row){

      this.addForm.deviceQLSignCode = row.deviceQLSignCode;

      this.listBmd();

    },

    closeSelf() {
      this.$emit("closeMe");
    },

    listBmd(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DeviceQLSign/ListPhone",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceQLSignCode: this.addForm.deviceQLSignCode
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.listPhone=response.data.data.list;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = "";
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLSign/SetBmdPhone",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeMe");

          this.$message.success("设置成功")

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },

    deleteRow(row){

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DeviceQLSign/DeletePhone",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          bmdPhoneCode: row.bmdPhoneCode
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.listBmd();

            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    AddBmd(){
      this.$refs.myAddBmdCTD.init(this.addForm.deviceQLSignCode);
      this.addShow =!this.addShow;
    },


  }
}

</script>


<style lang="scss" scoped>

</style>
